import { oz } from '@weft/utils';
import { AggregationAverageMethodSchema, AggregationDistinctMethodSchema, AggregationFirstMethodSchema,
  AggregationLastMethodSchema, AggregationMaxMethodSchema, AggregationMinMethodSchema, AggregationSumMethodSchema } from './aggregation-method-with-field-schemas';

export const ParameterizedAggregationMethodSchema = oz.union([
  AggregationSumMethodSchema,
  AggregationAverageMethodSchema,
  AggregationDistinctMethodSchema,
  AggregationFirstMethodSchema,
  AggregationLastMethodSchema,
  AggregationMaxMethodSchema,
  AggregationMinMethodSchema,
]);

export type ParameterizedAggregationMethod = oz.infer<typeof ParameterizedAggregationMethodSchema>;